import { parse, isValid } from 'date-fns'

export function stringToDate(value: string): Date | null {
  const date = parse(value, 'yyyy-MM-dd', new Date())
  if (isValid(date)) {
    return date
  }

  return null
}
